<template>
  <b-dropdown
    ref="dropdown"
    :can-close="canClose"
    @active-change="returnToCampaigns"
  >
    <div class="has-text-weight-bold" style="cursor: pointer" slot="trigger">{{ step.value }} {{ step.value === 1 ? 'Lead' : 'Leads' }}</div>

    <b-dropdown-item :focusable="false" custom style="min-width: 370px">
      <button
        v-show="isInRecords"
        type="button"
        class="delete is-pulled-right close-btn"
        @click="returnToCampaigns"
      ></button>

      <div class="has-text-weight-bold has-text-centered px-100">
        {{ step.label }}
        <div v-if="isInRecords" class="is-size-7">{{ selectedCampaign.label }}</div>
      </div>
      <div class="records-container">

        <div v-if="!isInRecords" class="mt-100">
          <div
             @click="openRecordList(campaignFilter, true)"
             class="campaign records-link"
          >
            All<span class="has-text-weight-normal"> ({{ step.value }})</span>
          </div>
          <div
            v-for="campaign in step.campaigns"
            @click="openRecordList([campaign])"
            :class="['campaign', { 'records-link': campaign.value > 0 }]"
          >
            {{ campaign.label }}
            <span class="has-text-weight-normal">({{ campaign.value }} {{ campaign.value === 1 ? 'Lead' : 'Leads' }})</span>
          </div>
        </div>

        <template v-else>
          <div v-if="records.length" class="mt-100">
            <stats-kpi-record-item
              v-for="record in records"
              @recordOpen="toggle"
              :record="record"
              :key="record.id"
            ></stats-kpi-record-item>
          </div>

          <div v-if="isLoading" style="min-height: 80px">
            <b-loading class="app-loader" :active="isLoading" :is-full-page="false"></b-loading>
          </div>
        </template>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import StatsKpiRecordItem from './StatsKpiRecordItem';

export default {
  components: { StatsKpiRecordItem },
  props: {
    step: Object,
    timeframe: Object,
    campaignFilter: Array,
  },
  data() {
    return {
      isLoading: true,
      isInRecords: false,
      canClose: true,
      selectedCampaign: null,
      records: []
    }
  },
  methods: {
    openRecordList(campaigns, isAll) {
      const start_at = this.timeframe.start_at.toISOString();
      const end_at = this.timeframe.end_at.toISOString();
      let campaignIds = [];

      this.records = [];
      this.isLoading = true;

      if (!isAll) {
        campaignIds = campaigns.map(c => c.id);
        this.selectedCampaign = campaigns[0];
      } else {
        campaignIds = campaigns
        this.selectedCampaign = { label: 'All' };
      }

      this.canClose = false;
      this.isInRecords = true;

      setTimeout(() => {
        this.canClose = true;
      }, 300);

      this.$api.stats.getFunnelStatRecords(this.step.api, { start_at, end_at, campaigns: campaignIds }).then((res) => {
        this.isLoading = false;
        this.records = res.data;
      });
    },
    returnToCampaigns() {
      this.canClose = false;
      this.isInRecords = false;
      this.selectedCampaign = null;

      setTimeout(() => {
        this.canClose = true;
      }, 300);
    },
    toggle() {
      this.$refs.dropdown.toggle();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.records-container {
  cursor: initial;
  max-height: 400px;
  overflow: auto;
  padding: 0 5px;
  position: relative;
}

.campaign {
  padding: 8px;
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 4px;
  box-shadow: 0 2px 3px rgba($dark, 0.1), 0 0 0 1px rgba($dark, 0.1);
}

.records-link {
  cursor: pointer;
  &:hover {
    background: $grey-100;
  }
}

.close-btn {
  position: absolute;
  right: 10px;
}
</style>
